import React from "react"
import Grid from "@material-ui/core/Grid"
import styled from "styled-components"
import { Field } from "react-final-form"
import MyTextField from "src/features/Components/TextField"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import { KeyboardDatePicker } from "@material-ui/pickers"
import Button from "@material-ui/core/Button"
import SearchIcon from "@material-ui/icons/Search"

const SearchWrapper = styled(Grid).attrs({
  container: true,
})`
  margin-top: 8px;
`

const DateInput = styled(KeyboardDatePicker)`
  .MuiInput-underline {
    &:before {
      border-bottom: none !important;
    }
    &:after {
      border-bottom: none !important;
    }
  }
`

const useStyles = makeStyles((theme) => ({
  date_input: {
    display: "flex",
    alignItems: "center",
    height: 33,
    width: 200,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(1),
    borderRadius: 17,
    position: "relative",
  },
  date_placeholder: {
    position: "absolute",
  },
  button: {
    borderRadius: 50,
  },
  to_text: {
    marginTop: 5,
  },
}))

function Search() {
  const classes = useStyles()
  return (
    <SearchWrapper spacing={2}>
      <Grid item>
        <Field
          name="search_name"
          placeholder="Search by Search name"
          component={MyTextField}
        />
      </Grid>
      <Grid item>
        <Field
          name="barcode"
          placeholder="Search by Barcode"
          component={MyTextField}
        />
      </Grid>
      <Grid item>
        <Paper elevation={0} className={classes.date_input}>
          <Field
            name="start_date"
            type="select"
            render={(props) => {
              return (
                <>
                  {!!!props.input.value && (
                    <Typography
                      color="textSecondary"
                      className={classes.date_placeholder}
                    >
                      Start Date
                    </Typography>
                  )}
                  <DateInput
                    clearable
                    format="dd/MM/yyyy"
                    {...props.input}
                    value={props.input.value || null}
                    helperText=""
                  />
                </>
              )
            }}
          />
        </Paper>
      </Grid>
      <Grid item className={classes.to_text}>
        —
      </Grid>
      <Grid item>
        <Paper elevation={0} className={classes.date_input}>
          <Field
            name="end_date"
            type="select"
            render={(props) => {
              return (
                <>
                  {!!!props.input.value && (
                    <Typography
                      color="textSecondary"
                      className={classes.date_placeholder}
                    >
                      End Date
                    </Typography>
                  )}
                  <DateInput
                    clearable
                    format="dd/MM/yyyy"
                    {...props.input}
                    value={props.input.value || null}
                    helperText=""
                  />
                </>
              )
            }}
          />
        </Paper>
      </Grid>
      <Grid item>
        <Button
          size="small"
          color="primary"
          className={classes.button}
          variant="contained"
          disableElevation
          type="submit"
        >
          <SearchIcon />
        </Button>
      </Grid>
    </SearchWrapper>
  )
}

export default Search
